<template>
    <v-col cols="12" class="py-0">
        <v-checkbox
            v-model="localModule.checked"
            :label="getName()"
            :ripple="false"
            @change="change"
            :disabled="localModule.locked"
            class="mt-0 mb-2"
            hide-details
        ></v-checkbox>
    </v-col>
</template>

<script>
import { getOptionalPrefillFromCustomer } from '@/shared/utils/moduleUtils'

export default {
    props: {
        module: {
            type: Object,
            require: true,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        fixedModules: {
            type: Array,
            default: () => [],
        },
        activeModuleIds: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            suppressChange: false,
            localModule: this.module,
        }
    },

    mounted() {
        if (
            this.isActive &&
            !this.localModule.skipActivePrefill &&
            !this.localModule.checked &&
            getOptionalPrefillFromCustomer(
                this.activeModuleIds,
                this.localModule,
                this.fixedModules,
            )
        ) {
            this.suppressChange = true
            this.localModule.checked = true
            this.$emit('checked', this.localModule)
            this.$nextTick(() => {
                this.suppressChange = false
            })
        }
    },

    methods: {
        change() {
            if (this.localModule.checked) {
                this.$set(this.localModule, 'skipActivePrefill', false)
            } else {
                this.$set(this.localModule, 'skipActivePrefill', true)
            }

            if (this.suppressChange) {
                this.suppressChange = false
                return
            }

            if (!this.localModule.locked) {
                this.$emit('checked', this.localModule)
            }
        },

        getName() {
            if (this.localModule.module.third_party) {
                return (
                    this.localModule.module.name +
                    '* (' +
                    this.$n(this.localModule.price, 'currency') +
                    ')'
                )
            }

            return this.localModule.module.name
        },

        update(module) {
            this.localModule.locked = module.locked
        },
    },
}
</script>

<style></style>
